import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { IAppointment } from '../../programari/programari.interface';
import { ICerere } from '../../cereri/cereri.interface';
import { CereriService } from '../../cereri/cereri.service';

@Component({
    selector: 'app-view-expansion-panel',
    templateUrl: './view-expansion-panel.component.html',
    styleUrls: ['./view-expansion-panel.component.scss']
})
export class ViewExpansionPanelComponent implements OnInit {
    @Input() appointment!: IAppointment;
    @Input() cerere!: ICerere;

    constructor(
        private cereriService: CereriService,
    ) { }

    ngOnInit(): void {
        console.log('appointment', this.appointment);
        console.log('cerere', this.cerere);
    }
}
